import INVITATION from './invitation';
import USER_ENTITY_INVITATION from './user-entity-invitation';

const INVITATIONS = { INVITATION, USER_ENTITY_INVITATION };

export default INVITATIONS;
